import React from 'react';
import FieldPlayersCount from '../elements/FieldPlayersCount/FieldPlayersCount';
import FieldPreview from '../FieldPreview/FieldPreview';
import FieldPreviewLegend from '../FieldPreview/FieldPreviewLegend';

/**
 * Карточка поля, выбранного на прошлом экране: название, вместимость, схема и
 * легенда только по тому, что есть на этом поле.
 *
 * @param {Object} field
 * @param {Object} model — модель схемы (см. buildFieldPreviewModel)
 */
const HotSeatFieldCard = ({field, model}) => (
  <aside className="hot-seat-field-card">
    <div className="hot-seat-field-card_header">
      <span className="hot-seat-field-card_name">{field.name}</span>
      <FieldPlayersCount playersCount={field.playersCount}/>
    </div>
    <div className="hot-seat-field-card_picture">
      <FieldPreview
        model={model}
        title={field.name ? `Схема поля «${field.name}»` : 'Схема поля'}
        isUnitSizeShown
      />
    </div>
    <FieldPreviewLegend legendIds={model.legendIds} className="hot-seat-field-card_legend"/>
  </aside>
);

export default HotSeatFieldCard;
